import { Paragraph } from '../../../../Typography';

export const HeroBanner = (): JSX.Element => {
  return (
    <>
      <div className="text-s-48 md:text-s-36 sm:text-s-32 text-center font-bold">
        Import your transactions from anywhere
      </div>
      <div className="w-8/12 mx-auto md:w-full sm:w-full">
        <Paragraph className="mt-5 text-center text-s-20 font-normal">
          Connect with 30+ investment brokerage platforms, 100+ crypto
          exchanges, wallets, blockchains or services to import your P&L
          statements to file taxes
        </Paragraph>
      </div>
    </>
  );
};
